import { render } from "./PlayersLayer.vue?vue&type=template&id=940ef2a0&scoped=true&bindings={}"
import script from "./PlayersLayer.vue?vue&type=script&lang=ts"
export * from "./PlayersLayer.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-940ef2a0"

export default script